import { SelectOption } from '@fleet-beat/core';

export enum PropertyVehicleTypeEnum {
  Trucks = 0,
  PCV = 1,
  Agricultural = 2,
  Watercraft = 3,
  Aircraft = 4,
  Other = 5,
}

export const PropertyVehicleTypeOptions: SelectOption[] = [
  { value: PropertyVehicleTypeEnum.Trucks, label: 'Trucks' },
  { value: PropertyVehicleTypeEnum.PCV, label: 'Passenger cars & vans(PCV)' },
  { value: PropertyVehicleTypeEnum.Agricultural, label: 'Agricultural' },
  { value: PropertyVehicleTypeEnum.Watercraft, label: 'Watercraft' },
  { value: PropertyVehicleTypeEnum.Aircraft, label: 'Aircraft' },
  { value: PropertyVehicleTypeEnum.Other, label: 'Other ' },
];
